import * as mutations from '@/constant/store/MutationTypes'

const claimMutations = {

    [mutations.DECREASE_LOADING_COUNT_STATE] (state: any) {
        state.popup.fullPageLoadingCount -= 1
    },
    [mutations.INCREASE_LOADING_COUNT_STATE] (state: any) {
        state.popup.fullPageLoadingCount += 1
    }
}

export default claimMutations
